import type {ParsedCountry} from 'react-international-phone';
import type {PhoneInputProps} from 'react-international-phone';

export type OnPhoneInputChangeCallback = (value: string, metaData?: PhoneInputChangeCallbackMetadata) => void;

export interface PhoneInputChangeCallbackMetadata {
  country: ParsedCountry;
  /**
   * can't change the name as ESLint throws an error with the react-interntional-phone library,
   * but this will be the phone number properly formatted like +92 300-232323
   */
  inputValue: string;
}

export interface PhoneNumberInputProps extends PhoneInputProps {
  phoneNumber: string;
  onInputChange: OnPhoneInputChangeCallback;
  className?: string;
  size?: PhoneNumberInputSize;
  unstyled?: boolean;
}

export enum PhoneNumberInputSize {
  SMALL,
  MEDIUM,
}

export const MIN_PHONE_NUM_LENGTH = 7;
export const DEFAULT_COUNTRY = 'us';
export const DEFAULT_COUNTRY_CODE = '+1';
